import APIService from '../api';
export default class CampaignService extends APIService {
  checkBusiness() {
    return this.get('/admin/business/campaign/status');
  }
  checkStripeStatus() {
    return this.get('/v2/admin/business/stripe/connect/status');
  }

  registerBusiness(data: any) {
    return this.put('/admin/business/campaign', data);
  }
}
